import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Route, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DocumentServiceGateway } from 'src/app/application/gateway/DocumentServiceGateway';
import { ExportOfferDocumentGateway } from 'src/app/application/gateway/ExportOfferDocumentGateway';
import { ExportOfferGateway } from 'src/app/application/gateway/ExportOfferGateway';
import { ProductCertificateGateway } from 'src/app/application/gateway/ProductCertificateGateway';
import { ProductCertificate } from 'src/app/domain/models/ProductCertificate';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-upload-export-certificates',
  templateUrl: './upload-export-certificates.component.html',
  styleUrls: ['./upload-export-certificates.component.css']
})
export class UploadExportCertificatesComponent implements OnInit {


  @Input()
  exportOfferId: number | undefined
  @Input()
  orderId: string | undefined

  @Input()
  mode: "order" | "exportOffer" = "exportOffer";

  @Output() OnCancelEvent = new EventEmitter<void>();
  @Output() OnSaveEvent = new EventEmitter<void>();

  certificates: ProductCertificate[] = []
  selectedRows: ProductCertificate[] = []

  loading: boolean = false;


  constructor(private _router: Router,
    private _messageService: MessageService,
    private _productCertificateService: ProductCertificateGateway,
    private _documentService: DocumentServiceGateway,
    public translate: TranslateService) {

  }

  ngOnInit(): void {
    console.log(this.orderId);
    console.log(this.exportOfferId);
    this.getAllFreeCertificates()
  }

  getAllFreeCertificates() {
    this.loading = true
    this._productCertificateService.getAllFreeByProfile().subscribe({
      next: (v) => {
        this.certificates = v
        this.loading = false
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.ProductCertificate.ManyRetrieveError') });
        console.log(e)
        this.loading = false
      },
      complete: () =>  {
        this.loading = false
        console.info('Product Certificates query successfully')
      }
    })
  }

  saveCertificateEvent()
  {
    if(this.mode == "exportOffer")
    {
      this.copyCertificate()
    }else{
      this.assignCertificateToOrder()
    }
  }

  copyCertificate()
  {
    if(this.exportOfferId && this.selectedRows.length > 0)
    {
      this.loading = true;
      let ids = this.selectedRows.map(x => x.id);
      this._productCertificateService.copyCertificateToExportOffer(this.exportOfferId, ids).subscribe(
        {
          next: (v) => {
            this.loading = false;
            this.OnSaveEvent.emit();

          },
          error: (e) => {
            this.loading = false;
          }
        }
      )
    }

  }
  assignCertificateToOrder()
  {
    if(this.orderId && this.selectedRows.length > 0)
    {
      this.loading = true;
      let ids = this.selectedRows.map(x => x.id);

        this._productCertificateService.assignCertificateToImportOrder(this.orderId, ids).subscribe(
        {
          next: (v) => {
            this.loading = false;
            this._messageService.add({ severity: 'info',
              summary: this.translate.instant('MessageService.Summary.SuccessAction'),
              detail: this.translate.instant('MessageService.ProductCertificate.AssignSuccess')})
            this.OnSaveEvent.emit();


          },
          error: (e) => {
            this.loading = false;
            this._messageService.add({ severity: 'info',
              summary: this.translate.instant('MessageService.Summary.SuccessAction'),
              detail: this.translate.instant('MessageService.ProductCertificate.AssignError')})
          }
        }
      )
    }
  }
    getProductCertificateDocument(productCertificateId: number) {
    this._documentService.getProductCertificateDocument2(productCertificateId).subscribe((resultBlob: any) => {
      var downloadURL = window.URL.createObjectURL(resultBlob.body);
      window.open(downloadURL);})
  }

  getPdfUrl(certificate: ProductCertificate) {
    this.getProductCertificateDocument(certificate.id);
  }

  cancel()
  {
    this.OnCancelEvent.emit();
  }

}
